import { Link } from "react-router-dom";
import ProductCard from "../../catalogo/components/ProductCard";
import { useActiveOffers } from "../../../hooks/useActiveOffers";
import { useLang } from "../../../context/LanguageContext";

/**
 * Home teaser for currently-valid offers. Renders nothing when there are no
 * active offers, so the home page only surfaces the section while there is
 * something to show — mirroring the conditional "Ofertas" nav link.
 */
export default function FeaturedOffers() {
	const { offers, loading } = useActiveOffers();
	const { t } = useLang();

	// Offers are a secondary section — stay invisible while loading and when
	// there is nothing on sale, rather than reserving empty space.
	if (loading || offers.length === 0) return null;

	const display = offers.slice(0, 4);

	return (
		<section
			className="w-full bg-stone-50 py-16 md:py-20 px-4 sm:px-6"
			data-product-shop
		>
			<div className="max-w-screen-xl mx-auto">
				{/* Heading */}
				<div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-10 md:mb-12">
					<div>
						<span className="inline-flex items-center gap-1.5 bg-red-50 text-red-600 text-[10px] font-extrabold uppercase tracking-[0.2em] px-3 py-1 rounded-full mb-3">
							<i className="ri-price-tag-3-line" /> {t("offers_hero_badge")}
						</span>
						<h2 className="text-2xl md:text-3xl font-bold tracking-tight text-zinc-900">
							{t("offers_hero_title")}{" "}
							<span className="text-red-600">{t("offers_hero_title_accent")}</span>
						</h2>
					</div>
					<Link
						to="/ofertas"
						className="inline-flex items-center gap-2 text-red-600 hover:text-red-500 text-xs font-bold uppercase tracking-widest transition-colors cursor-pointer whitespace-nowrap group"
					>
						{t("offers_view_all")}
						<i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform" />
					</Link>
				</div>

				{/* Cards */}
				<div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
					{display.map((product) => (
						<ProductCard key={product.productId} product={product} />
					))}
				</div>
			</div>
		</section>
	);
}
